<template>
  <footer>
    <div class="footer-text">
      <div>
        <p>佳期大飯店</p>
        <p>澎湖縣馬公市中興路21號</p>
        <p>No. 21, Zhongxing Rd., Magong City, Penghu County</p>
        <p>電話06-9278100</p>
        <p>傳真06-9261740</p>
      </div>
      <div>
        <p>進退房時間</p>
        <p>check in &nbsp;&nbsp;&nbsp;: 每日下午三點後</p>
        <p>check out : 每日上午十點前</p>
        <p>櫃台服務時間24HRS</p>
        <p>penghu.hotel@msa.hinet.net</p>
      </div>
    </div>

    <div>
      <p class="text-center">佳期大飯店 2021© ALL RIGHTS RESERVED</p>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
footer {
  padding: 1%;
  background-color: #f2f2f2;
  p {
    color: black;
  }
}
.footer-text {
  padding-top: 2.5%;
  display: flex;
  justify-content: space-around;
}
@media screen and (max-width: 600px) {
  .footer-text {
    padding: 10%;
    flex-direction: column;
  }
}
</style>
